import { useTranslation } from "@coworker/locales";
import Linkbar from "@coworker/apprestructured/src/shared/components/Linkbar/Linkbar";
import FullScreenPopup from "@coworker/apprestructured/src/layout/components/FullScreenPopup/FullScreenPopup";
import FixaTabs, {
  FixaTab,
  FixaTabPanel,
} from "@coworker/apprestructured/src/shared/wrappers/FixaTabs/FixaTabs";
import { useQueryParamState } from "@coworker/apprestructured/src/shared/hooks/wizard/useWizard/useQueryParamState";
import styles from "./create-media-page.module.css";

export enum CreateMediaTab {
  BlankCanvas = "blank-canvas",
  CommonRetailSolutions = "common-retail-solutions",
}

const TAB_QUERY_KEY = "tab";

export function CreateMediaPage() {
  const { t } = useTranslation();

  const [activeTab, setActiveTab] = useQueryParamState<CreateMediaTab>(
    TAB_QUERY_KEY,
    CreateMediaTab.BlankCanvas
  );

  const linkbar = (
    <Linkbar
      currentLabel={t("createMediaString")}
      items={[
        {
          label: t("mediaMaintenanceString"),
          to: "/mediamaintenance",
        },
      ]}
    />
  );

  return (
    <FullScreenPopup noPadding linkbar={linkbar} fullHeightContent>
      <FixaTabs
        className={styles["tabs"]}
        data-testid="createMediaTabs"
        activeTab={activeTab}
        onTabChanged={(tabId: string) => setActiveTab(tabId as CreateMediaTab)}
        tabs={[
          <FixaTab
            key={CreateMediaTab.BlankCanvas}
            tabPanelId={CreateMediaTab.BlankCanvas}
            text={t("blankCanvasString")}
            data-testid="createMediaBlankCanvasTab"
          />,
          <FixaTab
            key={CreateMediaTab.CommonRetailSolutions}
            tabPanelId={CreateMediaTab.CommonRetailSolutions}
            text={t("commonRetailSolutionsString")}
            data-testid="createMediaCommonRetailSolutionsTab"
          />,
        ]}
        tabPanels={[
          <FixaTabPanel
            key={CreateMediaTab.BlankCanvas}
            tabPanelId={CreateMediaTab.BlankCanvas}
            className={styles["panel"]}
          />,
          <FixaTabPanel
            key={CreateMediaTab.CommonRetailSolutions}
            tabPanelId={CreateMediaTab.CommonRetailSolutions}
            className={styles["panel"]}
          />,
        ]}
      />
    </FullScreenPopup>
  );
}
